export const INTENTION_ADDING_START = 'INTENTION_ADDING_START';
export const INTENTION_ADDING_IN_PROGRESS = 'INTENTION_ADDING_IN_PROGRESS';
export const INTENTION_ADDING_SUCCESS = 'INTENTION_ADDING_SUCCESS';
export const INTENTION_ADDING_FAILURE = 'INTENTION_ADDING_FAILURE';
